const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const isProtectedSpace = () =>
  typeof window !== "undefined" && window.location.pathname.startsWith("/threshold");

export function trackEvent(event, value = null) {
  if (isProtectedSpace()) return; // the Threshold watches no one
  try {
    const payload = JSON.stringify({ event, value });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(
        `${API}/analytics`,
        new Blob([payload], { type: "application/json" })
      );
    } else {
      fetch(`${API}/analytics`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
        keepalive: true,
      });
    }
  } catch {
    /* analytics must never interrupt the experience */
  }
}

export function trackScrollDepth() {
  if (isProtectedSpace()) return () => {};
  const marks = [25, 50, 75, 100];
  const hit = new Set();
  let raf = 0;
  const measure = () => {
    raf = 0;
    const doc = document.documentElement;
    const pct = Math.round(
      ((window.scrollY + window.innerHeight) / doc.scrollHeight) * 100
    );
    for (const mark of marks) {
      if (pct >= mark && !hit.has(mark)) {
        hit.add(mark);
        trackEvent("scroll_depth", mark);
      }
    }
  };
  const onScroll = () => {
    if (!raf) raf = requestAnimationFrame(measure);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  return () => {
    cancelAnimationFrame(raf);
    window.removeEventListener("scroll", onScroll);
  };
}
